module.exports = __webpack_public_path__ + "img/grege.eb7afc94.jpeg";